<template>
  <div class="stepModal position-relative">
    <div class="modal fade" id="ticketCustomMessageModal" tabindex="-1" role="dialog" aria-labelledby="notesModal">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="notesModalHeader">
              Migration Proceedings of {{ domain }}
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div v-if="loading" class="loader"></div>
            <section v-else>
              <section v-if="showRequiredTasks">
                <h4>You have missed the following required task:</h4>
                <ul class="list-unstyled">
                  <li v-for="(task, index) of requiredTasks" :key="index" class="p-2 border-bottom">
                    <i class="fa fa-arrow-right text-primary mr-3 pull-left" /> <span v-html="(task.type === 'dropdown') ? task.answer : task.text" />
                  </li>
                </ul>
                <div class="row">
                  <div class="col-md-12">
                    <button class="btn btn-sm btn-success" @click="checkAllTask">Please Acknowledge</button>
                    <button class="btn btn-sm btn-primary pull-right" type="button" @click="showRequiredTasks = false">Continue</button>
                  </div>
                </div>
              </section>
              <section v-else>
                <form @submit.prevent="submit">
                  <div class="row">
                    <div class="col-md-12">
                      <label>Action:</label>
                      <select class="form-control h-43" v-model="action" required>
                        <option value="Leave in migration">{{ (migration.status === 'pending') ? 'Leave in migration' : 'Leave in review'}}</option>
                        <option value="Move to under review" v-if="migration.status === 'pending'" :disabled="requiredTasks.length > 0">Move to under review</option>
                        <option value="Move to finished" :disabled="requiredTasks.length > 0">Move to finished</option>
                      </select>
                    </div>
                  </div>
                  <section v-if="migration.ticketId">
                    <div class="row mt-3" >
                      <div class="col-md-6">
                        <label>Message:</label>
                        <textarea class="form-control" :required="action === 'Leave in migration' || sendTicketReply" rows="8" v-model="ticketMessage"></textarea>
                      </div>
                      <div class="col-md-6">
                        <label>Presets:</label>
                        <ul class="list-unstyled preset">
                          <li v-for="(macro, index) of presetMacros" :key="index" @click="useThisMacro(macro)">
                            <h6><span v-html="(macro.title)? macro.title : ''"></span></h6>
                            <span v-html="(macro.message) ? macro.message.split('\n')[0].substr(0,40).replace(/\n/g,'<br>') + '...' : macro.split('\n')[0].substr(0,40).replace(/\n/g,'<br>')"></span>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6">
                        <label>Select Status:</label>
                        <select class="form-control" v-model="ticketStatus">
                          <option value="Open">Open</option>
                          <option value="Closed">Closed</option>
                          <option value="Client-Reply">Client-Reply</option>
                          <option value="In-Progress">In-Progress</option>
                          <option value="Answered">Answered</option>
                        </select>
                      </div>
                      <div class="col-md-6">
                        <label>Select Priority:</label>
                        <select class="form-control" v-model="ticketPriority">
                          <option value="High">High</option>
                          <option value="Low">Low</option>
                          <option value="Medium">Medium</option>
                        </select>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <div class="custom-control custom-checkbox pull-left mt-3 ml-3 mr-sm-2">
                          <input type="checkbox" v-model="sendTicketReply" name="action" class="custom-control-input" id="ticket-reply" />
                          <label class="custom-control-label pt-1" for="ticket-reply">Send ticket reply</label>
                        </div>
                      </div>
                    </div>
                  </section>
                  <div class="row mt-3" v-else>
                    <div class="col-md-12">
                      <span class="text-danger">Ticket ID is not associated with this migration.</span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <button class="btn btn-sm btn-default" type="button" @click="showRequiredTasks = true" v-if="requiredTasks.length > 0">Back</button>
                      <button class="btn btn-sm btn-primary pull-right" type="submit" :disabled="action === 'Leave in migration' && !migration.ticketId">Submit</button>
                    </div>
                  </div>
                </form>
              </section>
            </section>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { db } from '@/firebase/init'
import swal from "sweetalert2";
import statisticsMixin from "@/mixins/statisticsMixin";
import axios from "axios";
export default {
  name: "ticketCustomMessage",
  mixins: [statisticsMixin],
  props: {
    presetMacros: {
      required: true,
      type: Array
    },
    tab: {
      default: "",
      type: String,
    }
  },
  data() {
    return {
      ticketMessage: null,
      ticketStatus: 'Answered',
      ticketPriority: 'Low',
      type: null,
      migration: {},
      loading: false,
      sendTicketReply: false,
      moveMigration: false,
      showRequiredTasks: false,
      index: null,
      action: 'Leave in migration',
      requiredTasks: []
    }
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    domain() {
      return (this.migration.siteDetails) ? this.migration.siteDetails.domainName : ''
    }
  },
  methods: {
    async sendSlackNotification(msg, showButton) {
      try {
        await this.$http.post('utilities/send-slack-notification', {
          grant_type: 'token',
          msg,
          showButton,
        });
      } catch (e) {
        console.log(e.toString())
      }
    },
    formatPrimaryDomainName(value) {
      const match = value.match(/(?:https?:\/\/)?(?:www\.)?([a-zA-Z0-9-]+(?:\.[a-zA-Z0-9]+)+)/i);

      // If there's a match, return the domain group
      if (match && match.length > 1) {
        return match[1];
      } else {
        return 'Account Based Operation'; // Return null if no match found
      }
    },
    async checkAllTask() {
      console.log(this.requiredTasks)
      this.loading = true;
      for (let task of this.requiredTasks) {
        if (this.type === 'active') {
          task.completed = true;
          task.completedBy = this.user.firstName + ' ' + this.user.lastName;
        } else {
          task.reviewed = true;
          task.reviewedBy = this.user.firstName + ' ' + this.user.lastName
        }
      }
      console.log('updating')
      await db.collection('savedMigrations').doc(this.migration.docId).update({
        checkList: this.migration.checkList,
        modified: new Date().toISOString()
      });
      console.log('updated')
      this.loading = false;
      this.requiredTasks = [];
      this.showRequiredTasks = false;
    },
    async load(migration, index, type) {
      this.requiredTasks = [];
      this.showRequiredTasks = false;
      $('#ticketCustomMessageModal').modal('show');
      this.loading = true;
      this.migration = migration
      this.type = type
      await this.getRequiredTasks();
      console.log(this.requiredTasks)
      if (this.requiredTasks.length > 0) {
        this.showRequiredTasks = true;
      }
      this.loading = false;
      this.index = index
    },
    async getRequiredTasks() {
      this.requiredTasks = [];
      for (let list of this.migration.checkList) {
        for (let task of list.tasks) {
          if (this.type === 'active' && (task.migration || task.required) && !task.completed) {
            this.requiredTasks.push(task)
          } else if (this.type === 'review' && (task.review || task.required) && !task.reviewed) {
            this.requiredTasks.push(task)
          }
        }
      }
    },
    async useThisMacro(macro) {
      this.loading = true
      let msg = (macro.message) ? macro.message : macro;
      const userRef = await db.collection('users').doc(this.migration.uid).get()
      const user = userRef.data()
      const username = user.firstName + ' ' + user.lastName
      const domain = this.migration.siteDetails.domainName
      msg = msg.replace(/{name}/g, username)
      msg = msg.replace(/{firstName}/g, user.firstName)
      msg = msg.replace(/{lastName}/g, user.lastName)
      msg = msg.replace(/{teamMember}/g, this.user.firstName)
      msg = msg.replace(/{domain}/g, domain)
      msg = msg.replace(/{signature}/g, this.user.signature)
      if (msg.includes('{ipaddress}') || msg.includes('{nameservers}') || msg.includes('{stagingurl}')) {
        const accountRef = await db.collection('hostingAccounts').doc(this.migration.uid).get()
        const {accounts} = accountRef.data()
        let selectedAccount = null
        for (const account of accounts) {
          if (account.primary.domain === domain) {
            selectedAccount = account.primary;
          }
          for (const addon of account.addon) {
            if (addon.domain === domain) {
              selectedAccount = addon;
            }
          }
        }
        if (selectedAccount) {
          const ip = selectedAccount.serverIP || 'N/A'
          const nameservers = (selectedAccount.cloudflare.nameserver1) ? '\n' + selectedAccount.cloudflare.nameserver1 + '\n' + selectedAccount.cloudflare.nameserver2 + '\n' : 'N/A'
          msg = msg.replace(/{ipaddress}/g, ip)
          msg = msg.replace(/{nameservers}/g, nameservers)
          msg = msg.replace(/{stagingurl}/g, domain.replace(/\./g, "") + '.bigscoots-staging.com')
        }
      }
      this.ticketMessage = msg;
      this.ticketStatus = (macro.status) ? macro.status : 'Answered';
      this.ticketPriority = (macro.priority) ? macro.priority : 'Low';
      this.loading = false
    },

    //Fetching data of domain hosting test iD
    async updateDomainStatus() {
      try {
        const activeDomainRef = await db
            .collection("hostingAccounts")
            .doc(this.migration.uid)
            .get();
        if (!activeDomainRef.exists) { //uid exists
          return
        }
        const {accounts} = activeDomainRef.data();
        let currentObject = null;
        for (const account of accounts) { //getting accounts
          if (
              this.migration.siteDetails.domainName === account.primary.domain
          ) {
            currentObject = account.primary;
            break;
          } else {
            for (const addon of account.addon) {
              if (this.migration.siteDetails.domainName === addon.domain) {
                currentObject = addon;
                break;
              }
            }
          }
        }
        if (!currentObject || currentObject.status === "active") { // checking if object is empty or already assign status of active
          console.log("Domain not found or already active!!");
          return;
        }
        currentObject.status = "active";
        await db.collection("hostingAccounts").doc(this.migration.uid).update({
          accounts,
          updatedAt: new Date().toISOString()
        });
        await this.$http.post("/status_cake/update_test_with_status", { //calling api
          statusCakeId: currentObject.statusCakeTestId,
          status: "active",
          UID: this.migration.uid,
          domain: currentObject.domain,
          monitorId: currentObject.monitorId
        });
        await this.addLog({
          uid: this.migration.uid,
          primaryPlan: this.formatPrimaryDomainName(this.migration.primaryPlan),
          message: `Status in status cake test has been updated to active for Domain: ${this.domain}.`,
          level: "info"
        })

        await this.addLog({
          uid: this.migration.uid,
          primaryPlan: this.formatPrimaryDomainName(this.migration.primaryPlan),
          message: `Domain: ${this.domain}'s status has been updated from pending to active in WPO.`,
          level: "info"
        })
      } catch (e) {
        await this.addLog({
          uid: this.migration.uid,
          primaryPlan: this.formatPrimaryDomainName(this.migration.primaryPlan),
          message: `Error in updating domain's status, Domain: ${this.domain} Error: ${e.toString()}.`,
          level: "danger"
        })
        console.log("Error in updating domain status");
        console.log(e.toString());
      }
    },
    async submit() {
      try {
        this.loading = true
        if (((this.ticketMessage && this.action === 'Leave in migration') || this.sendTicketReply) && this.migration.ticketId) {
          await this.$http.post('utilities/send-migration-ticket-reply', {
            grant_type: 'token',
            message: this.ticketMessage,
            status: this.ticketStatus,
            priority: this.ticketPriority,
            ticketId: this.migration.ticketId,
            name: this.user.firstName + ' ' + this.user.lastName
          })
          if (this.action === 'Leave in migration' && this.type === 'active') {
            await this.addLog({
              uid: this.migration.uid,
              primaryPlan: this.formatPrimaryDomainName(this.migration.primaryPlan),
              message: `User has replied to ticket for migration ${this.domain} and leave it in active tab. Ticket No.: ${this.migration.ticketId}`,
              level: "info"
            })
          } else if (this.action === 'Leave in migration' && this.type === 'review') {
            await this.addLog({
              uid: this.migration.uid,
              primaryPlan: this.formatPrimaryDomainName(this.migration.primaryPlan),
              message: `User has replied to ticket for migration ${this.domain} and leave it in review tab.  Ticket No.: ${this.migration.ticketId}`,
              level: "info"
            })
          } else {
            await this.addLog({
              uid: this.migration.uid,
              primaryPlan: this.formatPrimaryDomainName(this.migration.primaryPlan),
              message: `User has replied to ticket for migration ${this.domain}. Ticket No.: ${this.migration.ticketId}`,
              level: "info"
            })
          }
        }
        const from = (this.type === 'active') ? 'active' : 'review'
        if (this.action === 'Move to under review') {
          await db.collection('savedMigrations').doc(this.migration.docId).update({
            status: 'review',
            modified: new Date().toISOString(),
            movedAt: new Date().toISOString()
          })
          $('#collapse_' + this.index + this.type).collapse('hide')

          const msg = `${this.domainAdjustment(this.domain)} has been migrated from ${from} to review by ${this.user.firstName} ${this.user.lastName} and is ready for review.`
          await this.addRecentActivity({
            type: 'info',
            actionType: `migration`,
            message: msg,
            customer: {
              domain: this.domain,
              email: this.migration.email
            }
          })
          try {
            await this.removeAdminActiveTask({taskId: this.migration.docId});
          } catch (e) {
            console.log(e.toString())
          }
          await this.sendSlackNotification(msg, true)
          await this.addLog({
            uid: this.migration.uid,
            primaryPlan: this.formatPrimaryDomainName(this.migration.primaryPlan),
            message: `User has moved migration ${this.domain} from ${from} to review.`,
            level: "info"
          })
          await this.updateDomainStatus();
          await this.changeTagStatus('Awaiting peer review')
          // increment count
          try {
            await this.incrementCountBasedOnType(this.user, 'migration')
          } catch (e) {
            console.log('line 370', e.toString())
          }
          try {
            const ref = await db.collection('domains').where('domain', '==', this.domain).where('uid', '==', this.migration.uid).limit(1).get();
            console.log('ref', ref.size)
            if (ref.size) {
              console.log('ref.size', ref.size);
              console.log('synchronizing data of php, wp, cache and auto updates')
              const response = await this.$patchStackService.post('/sync-versions/wp_and_auto_updates', {
                grant_type: 'token',
                ip: ref.docs[0].data().ip,
                domain: this.domain
              });
              console.log('response', response)
            }
          } catch (e) {
            console.log('error while synchronizing data')
          }
          try {
            await this.syncPluginDatabase()
          } catch (e) {
            console.log('error occurred in syncing patch stack plugins')
          }
        } else if (this.action === 'Move to finished') {
          await db.collection('savedMigrations').doc(this.migration.docId).update({
            status: 'finished',
            modified: new Date().toISOString(),
            movedAt: new Date().toISOString()
          })
          $('#collapse_' + this.index + this.type).collapse('hide')
          await this.$parent.getUpdatedData();
          console.log('this migration ', this.migration)
          const msg = `${this.domainAdjustment(this.domain)} has been migrated from ${from} to finished by ${this.user.firstName} ${this.user.lastName}.`
          console.log('this migration ', this.migration)
          await this.addRecentActivity({
            type: 'info',
            actionType: `migration`,
            message: msg,
            customer: {
              domain: this.domain,
              email: this.migration.email
            }
          })
          try {
            await this.removeAdminActiveTask({taskId: this.migration.docId});
          } catch (e) {
            console.log(e.toString())
          }
          console.log('I was called');
          await this.sendSlackNotification(msg, false)
          await this.addLog({
            uid: this.migration.uid,
            primaryPlan: this.formatPrimaryDomainName(this.migration.primaryPlan),
            message: `User has moved migration ${this.domain} from ${from} to finished.`,
            level: "info"
          })
          if (this.type === 'active') {
            await this.updateDomainStatus();
          }
          await this.changeTagStatus('Migrated')
          try {
            const incrementType = from === 'active' ? 'migration' : 'review'
            await this.incrementCountBasedOnType(this.user, incrementType)
          } catch (e) {
            console.log('line 392', e.toString())
          }
          try {
            const ref = await db.collection('domains').where('domain', '==', this.domain).where('uid', '==', this.migration.uid).limit(1).get();
            console.log('ref', ref.size)
            if (ref.size) {
              console.log('ref.size', ref.size);
              console.log('synchronizing data of php, wp, cache and auto updates')
              const response = await this.$patchStackService.post('/sync-versions/wp_and_auto_updates', {
                grant_type: 'token',
                ip: ref.docs[0].data().ip,
                domain: this.domain
              });
              console.log('response', response)
            }
          } catch (e) {
            console.log('error while synchronizing data')
          }
          try {
            await this.syncPluginDatabase()
          } catch (e) {
            console.log('error occurred in syncing patch stack plugins')
          }
        }
        this.loading = false
        this.ticketMessage = null
        this.action = 'Leave in migration'
        $('#ticketCustomMessageModal').modal('hide');
        try {
          if (this.tab !== '' || this.tab !== 'activeMigrations')
            await this.$parent.switchTab(this.tab);
        } catch (e) {
          console.log('error occurred in refreshing migration page')
        }
      } catch (e) {
        this.loading = false
        swal({
          title: "Error",
          text: e.toString(),
          type: "error"
        })
      }
    },
    async syncPluginDatabase() {
      try {
        const response = await this.$patchStackService.post('/patchstack/sync_plugins', {
          grant_type: 'token',
          ip: this.migration.uid,
          domain: this.domain,
          planIndex: this.migration.selectedPlan.planIndex,
          uid: this.docID
        });
        console.log('successfully patch stack plugins', response)

      } catch (e) {
        console.log('error occurred while updating patch stack plugins')
      }
    },
    async changeTagStatus(status) {
      try {
        const activeDomainRef = await db
            .collection("hostingAccounts")
            .doc(this.migration.uid)
            .get();
        if (!activeDomainRef.exists) { //uid exists
          return
        }
        const {accounts} = activeDomainRef.data();
        let currentObject = null;
        for (const account of accounts) { //getting accounts
          if (
              this.migration.siteDetails.domainName === account.primary.domain
          ) {
            currentObject = account.primary;
            break;
          } else {
            for (const addon of account.addon) {
              if (this.migration.siteDetails.domainName === addon.domain) {
                currentObject = addon;
                break;
              }
            }
          }
        }
        console.log(currentObject)
        if (!currentObject) {
          return
        }
        if (currentObject.tags) {
          const selectedTag = currentObject.tags.find((tag) => {
            return tag.title === 'Pending Migration' || tag.title === 'Migration' || tag.title === 'Awaiting peer review'
          })
          if (selectedTag) {
            selectedTag.title = status
          } else {
            currentObject.tags.push({title: status, type: 'badge-warning'})
          }
        } else {
          currentObject.tags = [{title: status, type: 'badge-warning'}]
        }
        await db.collection("hostingAccounts").doc(this.migration.uid).update({
          accounts,
          updatedAt: new Date().toISOString()
        });
      } catch (e) {
        console.log(e.toString());
        console.log('Error in changing migration tag status')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.modal-lg {
  max-width: 1200px !important;
}

.preset {
  height: 230px;
  overflow: auto;

  li {
    cursor: pointer;
    border: 1px solid rgba(0, 0, 0, 0.3);
    padding: 2px;
    background-color: rgba(0, 0, 0, 0.1);
    border-radius: 3px;
    margin: 2px 0;
  }
}
</style>
